import { queryOptions } from '@tanstack/react-query';

import {
  getCompaniesQuery,
  getCompanyForecastedRevenueQuery,
  getCompanyHistoricalRevenueQuery,
  getCompanyQuery,
} from './shared';

export const getCompanyQueryOptions = (id: string) => queryOptions(getCompanyQuery(id));
export const getCompaniesQueryOptions = () => queryOptions(getCompaniesQuery());

type CompanyFinancials = {
  forecastedRevenue: Awaited<ReturnType<ReturnType<typeof getCompanyForecastedRevenueQuery>['queryFn']>>;
  historicalRevenue: Awaited<ReturnType<ReturnType<typeof getCompanyHistoricalRevenueQuery>['queryFn']>>;
};

export const getCompanyFinancialsQueryOptions = (id: string, wholesaleMode: boolean = false) =>
  queryOptions<CompanyFinancials>({
    queryKey: ['companyFinancials', id, wholesaleMode],
    queryFn: async () => {
      const [forecastedRevenue, historicalRevenue] = await Promise.all([
        getCompanyForecastedRevenueQuery(id, wholesaleMode).queryFn(),
        getCompanyHistoricalRevenueQuery(id, wholesaleMode).queryFn(),
      ]);
      return { forecastedRevenue, historicalRevenue };
    },
  });
